/* eslint-disable no-param-reassign */
import React from 'react';
import { useTranslation } from 'react-i18next';
import SimpleTooltip from '@panel/commons/lib/Tooltip/SimpleTooltip';
import { sendTrackingInfo } from '@panel/commons';
import { BulkActionIcon, BulkActionIconContainer, BulkActionContainer, BulkActionText } from '../styles';

const Publish = ({ postings, setBulkActionsModals, bulkActionsModals, device }) => {
  const { t } = useTranslation();
  const unAuthorizedStates = ['DRAFT'];

  // SE COMPRUEBA QUE NO HAYAN POSTINGS SELECCIONADOS CON ESTADOS PROHIBIDOS Y QUE NO HAYAN DESARROLLOS Y COMUNES MEZCLADOS
  const publishAvailable =
    postings &&
    postings.some(p => p.checked) &&
    !postings.some(p => p.checked && unAuthorizedStates.some(state => state === p.stateAndDates[0].status)) &&
    !(
      postings.some(p => p.checked && p.publicationType !== 'Clasificado') &&
      postings.some(p => p.checked && p.publicationType === 'Clasificado')
    );

  const postingsToPublish = publishAvailable
    ? postings.reduce((publishArray, currentPosting) => {
        if (currentPosting.checked) publishArray.push(currentPosting.postingId);
        return publishArray;
      }, [])
    : [];

  const publicationType = publishAvailable
    ? postings.reduce((pType, currentPosting) => {
        if (currentPosting.checked) pType = currentPosting.publicationType;
        return pType;
      }, '')
    : '';

  const postingsInfoSelected = publishAvailable
    ? postings.reduce((pStatus, currentPosting) => {
        // Se validan los postings seleccionados en el bulk y luego se arma un objeto con el postingId como clave y valor igual a un objeto con claves: status y publicationPlanId.
        // Ej.: postingIds seleccionados: 12354 y 456789. => return {12354:{status:'ONLINE', publicationPlanId: 2}, 456789:{status:'OFFLINE', publicationPlanId: 52}}
        if (currentPosting.checked) {
          pStatus[currentPosting.postingId] = {
            status: currentPosting.stateAndDates?.[0]?.status,
            publicationPlanId: currentPosting.publicationPlanId
          };
        }
        return pStatus;
      }, {})
    : {};

  if (publishAvailable) {
    return (
      <BulkActionContainer
        onClick={() => {
          setBulkActionsModals({
            ...bulkActionsModals,
            publish: { open: true, postingList: postingsToPublish, publicationType, postingsInfoSelected }
          });
          sendTrackingInfo('Panel', 'Mis avisos', 'Bulk-Publicar');
        }}
        className='insideSelector'
      >
        <SimpleTooltip
          isMobile={device === 'tablet'}
          position='top-center'
          text={t('panel.bar.select.actions.publish')}
        >
          <BulkActionIconContainer device={device}>
            <BulkActionIcon action='publish' />
          </BulkActionIconContainer>
        </SimpleTooltip>
        {device === 'tablet' && <BulkActionText>{t('panel.bar.select.actions.publish')}</BulkActionText>}
      </BulkActionContainer>
    );
  }
  return null;
};

export default Publish;
